import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import SopLoadingAnimation from "../../components/sopLoadingAnimation";
import { formatarDecimal, formatarPorcentagem } from "../../core/utils/funcoes";
import { useToast } from "../../core/contexts/toast";
import { t } from "i18next";
import { RepositorioSopSales } from "../../core/repositories/sopSalesRepositorio";
import { useAutenticação } from "../../core/contexts/auth";
import { FaArrowUp, FaArrowDown } from "react-icons/fa";
import { ModeloSopSales } from "../../core/models/sopSales";


interface Props {
    // modalInfo?: { label: string, index: number, currentValue: number | null, currentValueDestaque: number | null };
    showModal?: boolean;
    label?: string;
    // currentValue?: number | null;
    // currentValueDestaque?: number | null;
    filtro: any;
    linha?: ModeloSopSales;
    salvarValor: (newValue: number) => void;
    setShowModal: (show: boolean) => void;
    // title: string;
}

export default function ModalEditForecastValue(props: Props) {

    const [novoValor, setNovoValor] = React.useState<string>("");
    // const [showModal, setShowModal] = React.useState<boolean>(false);
    const [showCarregando, setShowCarregando] = React.useState<boolean>(false);

    const { mostrarToast } = useToast();

    const { usuario } = useAutenticação();

    function CalcPercent(item1?: any, item2?: any) {
        if (item1 && item2) {
            item1 = Number.parseFloat(item1);
            item2 = Number.parseFloat(item2);
            return (item1 - item2) / item2;
        } else {
            return 0;
        }
    }

    function varicaoPreco(preco1?: number, preco2?: number) {
        if (!preco1 || !preco2) {
            return "-"
        }
        var a = CalcPercent(preco1, preco2)
        if (a > 0) {
            return <>
                <span style={{ color: "green" }}>{formatarPorcentagem(a)}</span>
                <FaArrowUp color="green" />
            </>
                ;
        } else if (a < 0) {
            return <>
                <span style={{ color: "red" }}>{formatarPorcentagem(a)}</span>
                <FaArrowDown color="red" />
            </>
        } else {
            return <span>{formatarPorcentagem(a)}</span>;
        }
    }

    function salvarValor() {
        // if (!modalInfo || !data || !data.datasets) return;

        // var mes = (data.labels?.[modalInfo?.index ?? 0] ?? '').toString();
        // const { label, index } = modalInfo;

        // const dataset = data.datasets.find(d => d.label === "Forecast - Edit");
        // if (!dataset) return;

        // setShowModal(false);
        // setShowCarregando(true);

        // const currentValue = dataset.data[index] as number | 0;
        // const diff = ((novo - currentValue) / currentValue);

        // dataset.data[index] = novo;
        // setData({ ...data });
        // chartRef.current?.update();

        // props.onChange?.(mes, diff);
        // setTimeout(() => {
        //     setShowCarregando(false);
        // }, 1500);

        const novo = parseFloat(novoValor);
        if (isNaN(novo)) return;
        props.setShowModal(false);
        const _centro = new RepositorioSopSales();
        var filtroAux = { ...props.filtro }
        filtroAux.cod_usuario = usuario?.cod_usuario;
        // filtroAux.des = mes;
        filtroAux.des_valor = novoValor
        filtroAux.cod_product = props.linha?.cod_product;
        filtroAux.cod_business_unit = props.linha?.cod_business_unit;
        filtroAux.cod_region = props.linha?.cod_region;

        setShowCarregando(true)
        _centro.postSimular(filtroAux).then((atualizadas) => {
            if (atualizadas) {
                props.salvarValor(novo);
            }
            setShowCarregando(false)
            mostrarToast({
                titulo: "Success",
                mensagem: `Updated line(s)`,
                tipo: "success",
            });
        }).catch(err => {
            setShowCarregando(false)
            mostrarToast({
                titulo: "Erro",
                mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
                tipo: "error",
            });
        });
    };

    return (
        <>
            <Modal show={props.showModal} onHide={() => props.setShowModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Forecast Value ({props.linha?.des_product})</Modal.Title>
                </Modal.Header>
                <Modal.Body className='mt-0 pt-0'>
                    <Form.Group>
                        <Form.Label>
                            Value IA: {formatarDecimal(props.linha?.num_sales_forecast_units)} <br />

                            {props.linha?.num_sales_new ? <>
                                Value Edit: {formatarDecimal(props.linha?.num_sales_new)} <br />
                                Δ {props.linha?.num_sales_new !== null ? formatarDecimal(props.linha?.num_sales_new! - props.linha?.num_sales_forecast_units!, props.filtro?.value !== "Quantity").replace("R$", "$") : 'N/A'}
                                | {varicaoPreco(props.linha?.num_sales_new || 0, props.linha?.num_sales_forecast_units || 0)}
                            </>: ""}
                        </Form.Label>
                        <Form.Control
                            type="number"
                            value={novoValor}
                            onChange={(e) => setNovoValor(e.target.value)}
                            placeholder="New value"
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => props.setShowModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={salvarValor}>Save</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showCarregando} onHide={() => setShowCarregando(false)} centered className='modal-transparent'>
                <Modal.Body className='border-0'>
                    <SopLoadingAnimation type="IA" />
                </Modal.Body>
            </Modal>
        </>)
}